import { endOfMonth, format, startOfMonth, subMonths } from "date-fns";

function formatDateRange(start, end) {
    const startDateFormat = start.getMonth() !== end.getMonth() ? "d MMMM" : "d";
    return `${format(start, startDateFormat)} - ${format(end, "d MMMM")}`;
}

export const dateRanges = [
    {
        name: "This Month",
        from: startOfMonth(new Date()),
        to: new Date(),
    },
    {
        name: "Last Month",
        from: startOfMonth(subMonths(new Date(), 1)),
        to: endOfMonth(subMonths(new Date(), 1)),
    },
    {
        name: "Last 3 Months",
        from: startOfMonth(subMonths(new Date(), 3)),
        to: endOfMonth(subMonths(new Date(), 1)),
    },
];

export const dateRangesDropdownOptions = dateRanges.map(range => ({
    key: range.name,
    text: `${range.name} (${formatDateRange(range.from, range.to)})`,
    value: range.name,
}));
